import(/* webpackMode: "eager" */ "/home/click-builder/cresivox/live/builder/src/app/global-error.tsx")